<template>
    <b-modal id="video-modal" hide-backdrop hide-header hide-footer>
        <template #default="{ hide }">
            <div class="rounded-10 overflow-hidden d-flex align-items-center justify-content-center w-100 h-100">
                <vue-plyr :options="options">
                    <video>
                        <source :src="skolyStorage + subor" />
                    </video>
                </vue-plyr>
            </div>
            <a class="btn --secondary --circle close-btn" @click="hide()"><span class="icon --close"></span></a>
        </template>
    </b-modal>
</template>

<script>
import EventService from "@/services/EventService";

export default {
    components: {},
    props: [
        'subor',
    ],
    data() {
        return {
            options: { controls: ['play', 'progress', 'current-time', 'mute', 'volume'], autoplay: true }
        }
    },
    computed: {
        skolyStorage() {
            return EventService.getUlohyStorageUrl()
        },
    },
}
</script>
